import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './cons-type-donation-document.reducer';
import { IConsTypeDonationDocument } from 'app/shared/model/cons-type-donation-document.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTypeDonationDocument = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const consTypeDonationDocumentList = useAppSelector(state => state.consTypeDonationDocument.entities);
  const loading = useAppSelector(state => state.consTypeDonationDocument.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="cons-type-donation-document-heading" data-cy="ConsTypeDonationDocumentHeading">
        <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.home.title">Cons Type Donation Documents</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.home.createLabel">
              Create new Cons Type Donation Document
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {consTypeDonationDocumentList && consTypeDonationDocumentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.folderName">Folder Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {consTypeDonationDocumentList.map((consTypeDonationDocument, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${consTypeDonationDocument.id}`} color="link" size="sm">
                      {consTypeDonationDocument.id}
                    </Button>
                  </td>
                  <td>{consTypeDonationDocument.code}</td>
                  <td>{consTypeDonationDocument.name}</td>
                  <td>{consTypeDonationDocument.nameAr}</td>
                  <td>{consTypeDonationDocument.nameEn}</td>
                  <td>{consTypeDonationDocument.folderName}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${consTypeDonationDocument.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTypeDonationDocument.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTypeDonationDocument.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTypeDonationDocument.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.home.notFound">
                No Cons Type Donation Documents found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ConsTypeDonationDocument;
